export class Section {
  public id: number;
  public code: number;
  public ordreFormulaire?: number;
  public intitule: string;
  public prefix?: string;

  constructor() {
  }
}
